{
  "title": "Friends",
  "playingNow": "Friends Playing Now",
  "viewAll": "View All",
  "score": "Score",
  "toPar": "To Par",
  "handicap": "HCP",
  "noFriends": "You don't have any friends yet. Start by adding with email or QR code.",
  "searchDescription": "Send a friend request by email address.",
  "searchPlaceholder": "Email...",
  "sendRequest": "Send Request",
  "requestSent": "Friend request sent successfully!",
  "sentRequests": "Sent Requests",
  "accept": "Accept",
  "decline": "Decline",
  "cancelRequest": "Cancel Request",
  "removeFriend": "Remove Friend",
  "blockUser": "Block User",
  "confirmRemove": "Are you sure you want to remove {{name}} from your friends?",
  "confirmBlock": "Are you sure you want to block {{name}}? This action will remove them from your friends and prevent them from sending you requests.",
  "tabs": {
    "myFriends": "My Friends",
    "findFriends": "Find Friends",
    "qrConnect": "QR Connect"
  },
  "qr": {
    "title": "Friend QR Code",
    "scanTitle": "Scan QR Code",
    "description": "Connect with friends in person by generating a QR code or scanning theirs.",
    "generateCode": "Generate My QR Code",
    "scanCode": "Scan Friend's QR Code",
    "instructions": "Show this QR code to your friend to connect instantly.",
    "scanInstructions": "Position the QR code within the frame to scan.",
    "usesRemaining": "Uses Remaining",
    "expiresAt": "Expires At",
    "generating": "Generating QR code...",
    "processing": "Processing...",
    "generateError": "Failed to generate QR code. Please try again.",
    "cameraError": "Unable to access camera. Please check permissions.",
    "acceptError": "Failed to accept friendship. This code may have expired.",
    "tryAgain": "Try Again"
  },
  "scorecard": {
    "course": "Course",
    "teeSet": "Tee Set",
    "started": "Started",
    "loadError": "Failed to load friend's scorecard. You may not have permission to view it.",
    "backToFriends": "Back to Friends",
    "autoRefresh": "Updates automatically every 2 minutes"
  },
  "removeFriendTitle": "Remove Friend",
  "blockUserTitle": "Block User",
  "sections": {
    "requests": "Friend Requests",
    "friends": "Friends"
  },
  "profile": {
    "roundsLabel": "Rounds",
    "averageLabel": "Average Score",
    "bestLabel": "Best Round",
    "recentRounds": "Recent Rounds",
    "noClub": "No Club",
    "showMore": "Show More",
    "noRounds": "No Rounds Yet",
    "loadError": "Failed to load friend's profile.",
    "notFound": "Friend not found.",
    "removeError": "Failed to remove friend.",
    "blockError": "Failed to block user.",
    "partialLoadError": "Not all data could be loaded."
  }
}
